import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/revisionActions'
import * as api from '../api/revision'

function* getRevisions(action) {
  try {
    const payload = yield call(api.getRevisions, {
      target_id: action.targetId,
      table: action.table
    })
    yield put({ type: constants.GET_REVISIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_REVISIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetRevisions() {
  yield takeLatest(constants.GET_REVISIONS.ACTION, getRevisions)
}

export function* rootSaga() {
  yield all([fork(watchGetRevisions)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/revisionSaga.js